<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" 
    size = "medium" 
    color = "#85bb65" 
    type = "square-jelly-box" 
    [fullScreen] = "true">
    <p style="color: white" > Loading... </p>
</ngx-spinner>

<router-outlet />